import { render } from "./HeaderAlerts.vue?vue&type=template&id=009be1ba&scoped=true&ts=true"
import script from "./HeaderAlerts.vue?vue&type=script&lang=ts"
export * from "./HeaderAlerts.vue?vue&type=script&lang=ts"

import "./HeaderAlerts.vue?vue&type=style&index=0&id=009be1ba&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009be1ba"]])

export default __exports__